﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import VectorSource from 'ol/source/Vector.js';
import { Utility } from '../Utility.js';
export { ContractorPoloTool };

/**
 * Class Urbanism tool
 */
const ContractorPoloTool = function ()
{
    // Define this
    var myContractorPoloTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Layer process information
    this._processLayerInfo = {};

    // Layer process information
    this._layerInfoToHighlight = [];

    // -- end private method ----------------------------------------------------------------------


    // -- begin public method ---------------------------------------------------------------------

    /**
     * Execute action from adicional parameter
     */
        //    '(' + workspace + ':' + 'g_acessorios_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_acessorios_transicao_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_origens_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_pontos_consumo_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_prm_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_purgas_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_reservatorios_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_proteccao_tubagem_cadastre' + ')' +
    this.ExecuteAdicionalParameter = function (codObra) {

        var TESTE = codObra;
        myContractorPoloTool._GotoCodObra(codObra)

    }

    this._GotoCodObra = function (codObra) {
        // Start wait
        myContractorPoloTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        var workspace = myContractorPoloTool._processLayerInfo.workspace;

        //var ListLayerInfo =
        //    '(' + workspace + ':' + 'g_ramais_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_tubagens_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_telemetria_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_unidades_filtragem_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_respiros_cadastre' + ')' +
        //    '(' + workspace + ':' + 'g_valvulas_cadastre' + ')';

        var ListLayerInfo = "";

        for (var i = 0; i < myContractorPoloTool._layerInfoToHighlight.length; i++) {

            ListLayerInfo += "(" + workspace + ":" +  myContractorPoloTool._layerInfoToHighlight[i] + ")";

        }

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: myContractorPoloTool._processLayerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": ListLayerInfo,
                "cql_filter": "cod_obra == '" + codObra + "'",
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    for (var i = 0; i < data.features.length; i++) {
                        
                        myContractorPoloTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                        var styleElement = myContractorPoloTool._mapSgs._defaultHighlighStyles;
                        myContractorPoloTool._mapSgs.featureToHighLight.getArray()[myContractorPoloTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                        // Set current features in overlay
                        myContractorPoloTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myContractorPoloTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    }
                    myContractorPoloTool._mapSgs.map.getView().fit(myContractorPoloTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myContractorPoloTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myContractorPoloTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    // -- end public method -----------------------------------------------------------------------


    // -- begin event -----------------------------------------------------------------------------



    // -- end event -------------------------------------------------------------------------------
}

/**
 * Init urbanism tool
 * @param {object} mapSgs, map object
 */
ContractorPoloTool.prototype.Init = function (mapSgs)
{
    if (!this._toolInitialize)
    {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;

        // Get layer process information
        var workspace = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CONTRACTOR_POLO", "LAYERINFO", "WORKSPACE");
        var geoserver = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CONTRACTOR_POLO", "LAYERINFO", "GEOSERVER");

        this._processLayerInfo = {
            workspace: (workspace === undefined) ? "" : workspace.value,
            geoserver: (geoserver === undefined) ? "" : geoserver.value
        };


        $.ajax({
            type: 'GET',
            url: '/rest/app/Import/GetAllLayersCadastre',
            async: false,
            success: function (data) {
                this_._layerInfoToHighlight = data.result;
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

    }
}